module.exports = __webpack_public_path__ + "static/img/RE12.0098a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE12.jpg
// module id = q90E
// module chunks = 0